import RecurrenceEnd from './RecurrenceEnd';

export default RecurrenceEnd;
